<template>
  <div>
    <Filters @close="posFilters" />

    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <!-- Items per page -->
          <b-row class="pb-2">
            <!-- Filter -->
            <b-col cols="12" sm="12" md="4">
              <div class="d-flex align-items-center">
                <!-- Filter Button-->
                <div class="mx-2">
                  <!-- <b-button v-b-modal.modal-filters-user variant="success">
                    Filtros
                  </b-button> -->
                </div>
                <!-- Filter Per Page -->
                <div class="m-0">Mostrar&nbsp;</div>
                <div class="m-0 p-0">
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </div>
                <div class="m-0 p-0">&nbsp;por página</div>
              </div>
            </b-col>
            <!-- Search -->
            <b-col cols="12" sm="12" md="8" class="d-flex justify-content-end align-items-center">
              <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                <label class="d-inline-flex align-items-center">
                  <b-form-input
                    v-model="searcher"
                    type="search"
                    placeholder="Nome ou email..."
                    class="form-control form-control-sm ml-2"
                    @input="onSearch"
                  ></b-form-input>
                </label>
              </div>
              <div class="d-inline-flex align-self-start ml-2">
                <b-form-select
                  v-model="status"
                  placeholder="Status"
                  :options="[
                    { value: null, text: 'Status', disabled: true },
                    { value: null, text: 'Todos' },
                    { value: 'in_progress', text: 'Em progresso' },
                    { value: 'pending_approval', text: 'Aprovação Pendente' },
                    { value: 'paid', text: 'Pago' },
                    { value: 'disapproved', text: 'Reprovado' },
                    { value: 'not_completed', text: 'Não completado' },
                    { value: 'approved', text: 'Aprovados' },
                    { value: 'created', text: 'Não resgatado' }
                  ]"
                  size="sm"
                  @input="changedFilter"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div v-if="cashback.length > 0 && !loading"
                class="table-responsive mb-0"
              >
                <b-table
                  responsive="sm"
                  sort-icon-left
                  :items="cashback"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                >
                  <!-- Body Tabel -->
                  <template v-slot:cell(id)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                      ></div>
                      <p>{{ data.item.id }}</p>
                    </div>
                  </template>
                  <template v-slot:cell(user_id)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                      ></div>
                      <p>{{ data.item.user_id }}</p>
                    </div>
                  </template>
                  <template v-slot:cell(name)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                      ></div>
                      <p>{{ data.item.user ? data.item.user.name : ''}}</p>
                    </div>
                  </template>
                  <template v-slot:cell(mail)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                      ></div>
                      <p>{{ data.item.user ? data.item.user.email : '' }}</p>
                    </div>
                  </template>
                  <template v-slot:cell(status)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                      ></div>
                      <p> {{ filterStatus(data.item.status) }} </p>
                    </div>
                  </template>
                  <template v-slot:cell(multiplier)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                      ></div>
                      <p>{{ formatMoney(data.item.amount_currently_achieved ? data.item.amount_currently_achieved : '0') }} de  {{ formatMoney(data.item.amount_to_achieve || 0) }}</p>
                    </div>
                  </template>
                  <template v-slot:cell(expiration)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                      ></div>
                      <p>{{ data.item.finish_until | datetime }}</p>
                    </div>
                  </template>

                  <template v-slot:cell(created_at)="data">
                    {{ data.value | datetime }}
                  </template>

                  <template v-slot:cell(_actions)="data">
                    <template v-if="data.item.status === 'pending_approval'">
                      <b-button
                        variant="success"
                        class="mr-2 mb-1"
                        @click="openApproveCashback(data.item)"
                      >
                        <i class="fas fa-check custom-width"></i>
                      </b-button>
                    </template>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
          <!-- Loading -->
          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <!-- Pagination -->
          <div v-if="cashback.length > 0" class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    @change="changeCurrentPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
          <!-- Feedback Message -->
          <div v-if="cashback.length === 0 && !loading"
            class="row justify-content-center"
          >
            <div class="alert alert-primary" role="alert">
              Sem metas cadastradas.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import appConfig from '@src/app.config'
import PageHeader from '@components/page-header'
import Filters from '@components/client/filters'
import Money from '@src/mixins/money'
import _ from 'lodash'
import validAcessRoute from './../../../utils/validAcessRoute'

import CashbackMetaService from '@services/resources/CashbackMetaService'
import ReleasePaymentService from '@services/resources/ReleasePaymentService'
const serviceMetaCashback = CashbackMetaService.build();
const serviceReleasePayment = ReleasePaymentService.build();

export default {
  name: 'Cashback',
  page: {
    title: 'Cashback',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { PageHeader, Filters },
  mixins: [Money],
  data() {
    return {
      status: null,
      title: 'Cashback',
      showToAdminFinancial: validAcessRoute(['administrator', 'financial', 'financialManager'], this.$store.getters.getProfile),
      compliance: validAcessRoute(['compliance'], this.$store.getters.getProfile),
      risco: validAcessRoute(['risk'], this.$store.getters.getProfile),
      attendance: validAcessRoute(['attendance'], this.$store.getters.getProfile),
      success: validAcessRoute(['success'],this.$store.getters.getProfile),
      financialAssistant: validAcessRoute(['financialAssistant'], this.$store.getters.getProfile),
      items: [
        { text: 'Início', href: '/'},
        { text: 'Cashback', active: true }
      ],
      cashback: [],
      loading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 50, 100, 500],
      filter: '',
      searcher: null,
      email: null,
      cpf: null,
      filters: {},
      sortBy: 'id',
      sortDesc: false,
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'user_id', label: 'Id do Usuário', sortable: true },
        { key: 'name', label: 'Nome', sortable: false },
        { key: 'mail', label: 'Email', sortable: false },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'multiplier', label: 'Meta', sortable: false },
        { key: 'expiration', label: 'Data limite', sortable: true },
        { key: 'created_at', label: 'Data de cadastro', sortable: true },
        { key: '_actions', label: 'Ações', sortable: false }
      ],
      useritem: {},
    }
  },
  filters: {
    
  },
  computed: {
    isHeaven() {
      return this.$store.getters["getIsHeaven"]
    }
  },
  watch: {
    perPage() {
      this.fetchUsers()
    },
  },
  mounted() {
    this.fetchCashback()
  },
  methods: {
    filterStatus(val) {
      const statusMap = {
        'in_progress': 'Em progresso',
        'approved': 'Aprovado',
        'pending_approval': 'Aprovação Pendente',
        'paid': 'Pago',
        'disapproved': 'Reprovado',
        'not_completed': 'Não completado',
        'created': 'Não resgatado'
      };

      return statusMap[val] || val;
    },
    changedFilter() {
      this.filters = { search: this.searcher, status: this.status }
      this.currentPage = 1
      this.fetchCashback(this.filters)
    },
    openApproveCashback(item) {
      Vue.swal({
        title: 'Aprovar cashback',
        text: 'Deseja aprovar o cashback?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        confirmButtonColor: '#28a745',
        cancelButtonColor: '#dc3545',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.approveCashback(item)
        }
      })
    },
    approveCashback(item) {
      serviceReleasePayment
        .create({ decision: 'approve' }, item.id)
        .then((resp) => {
          Vue.swal({
            title: 'Sucesso!',
            text: 'Cashback aprovado com sucesso!',
            icon: 'success',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#28a745',
          }).then(() => {
            this.fetchCashback()
          })
        })
        .catch(err => console.error(err))
    },
    onSearch() {
      this.filters = { search: this.searcher, status: this.status }
      this.currentPage = 1
      this.debounce()
    },
    debounce: _.debounce(function () {
      this.fetchCashback()
    }, 500),
    posFilters(filters) {
      this.filters = filters
      this.fetchCashback(this.filters)
    },
    changeCurrentPage(currentPage) {
      this.fetchCashback({}, currentPage)
    },
    fetchCashback(filters = this.filters, currentPage = null) {
      this.loading = true

      let data = {
        page: currentPage || this.currentPage,
        per_page: this.perPage
      }

      Object.keys(filters).forEach(
        (key) =>
          (filters[key] == null || filters[key].length === 0) &&
          delete filters[key]
      )
      data = Object.assign(data, filters)

      if (this.status) data.status = this.status

      serviceMetaCashback
        .search(data)
        .then((resp) => {
          this.cashback = resp.data
          this.totalRows = resp.total || 1
          this.currentPage = resp.current_page || 1
        })
        .catch(err => console.error(err))
        .finally(() => { this.loading = false })
    },
  }
}
</script>

<style scoped>
.custom-width {
  width: 18px;
}
</style>